<template>
  <el-dialog class="comp-reword-form" :visible.sync="visible" :show-close="false">
    <template slot="title">
      <div class="dialog-title flex flex-between">
        <div class="lef flex">
          <span class="reword-post">岗位悬赏-{{ postTitle }}</span>
          <span v-if="type === 'on'" class="status s-on">进行中</span>
          <span v-if="type === 'end'" class="status s-end">已终止</span>
        </div>
        <i class="el-icon-close close-btn" @click="close"></i>
      </div>
    </template>
    <div class="info-box flex">
      <div class="reword-no">悬赏任务编号：{{ detailInfo.code }}</div>
      <div v-if="type === 'on'" class="reword-no">悬赏任务截止时间: {{ detailInfo.planEndAt }}</div>
    </div>

    <!-- 悬赏中 -->
    <template v-if="type === 'on'">
      <div class="warn-btns flex flex-between">
        <span class="warn"><i class="el-icon-warning" />如需更改佣金请终止悬赏重新发布</span>
        <div class="btns">
          <el-button @click="handleAllHistory">全部岗位悬赏转发任务历史</el-button>
          <el-button class="btn-warn" @click="showConfirmDialog = true">终止悬赏</el-button>
        </div>
      </div>
      <div class="block-box flex">
        <div class="block-item flex" v-for="item in blockListOne" :key="item.key">
          <img class="icon-img" :src="iconInfo[item.key]" />
          <div class="text-box">
            <div class="label">{{item.label}}</div>
            <div class="value">{{detailInfo[item.field] || 0}}</div>
          </div>
        </div>
      </div>
    </template>

    <!-- 悬赏结束 -->
    <template v-if="type === 'end'">
      <div class="block-btns flex align-start flex-between">
        <div class="block-box flex">
          <div class="block-item flex" v-for="item in blockListTwo" :key="item.key">
            <img class="icon-img" :src="iconInfo[item.key]" />
            <div class="text-box">
              <div class="label">{{item.label}}</div>
              <div class="value">{{detailInfo[item.field] || 0}}</div>
            </div>
          </div>
        </div>

        <div class="btns">
          <el-button @click="handleAllHistory">全部岗位悬赏转发任务历史</el-button>
          <el-button class="btn-reword" @click="toConfig">重新发布悬赏</el-button>
        </div>
      </div>
    </template>

    <div class="table-box">
      <div class="table-tit flex">
        <span class="tit">岗位悬赏明细</span>
        <span class="total">{{ `共${tableTotal}条` }}</span>
      </div>
      <el-table :data="tableData" style="width: 100%; height: 400px; overflow-y: auto;">
        <el-table-column prop="toUserName" label="浏览用户" />
        <el-table-column prop="fromUserName" label="转发用户"  />
        <el-table-column prop="code" label="悬赏任务编号" width="120" />
        <el-table-column prop="rewardAt" label="浏览时间" width="120" />
        <el-table-column prop="rewardAmount" label="转发佣金(元)" />
      </el-table>
      <el-pagination
        v-if="tableTotal > 0"
        class="flex flex-end"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="tableTotal">
      </el-pagination>
    </div>

    <div class="confirm-box" v-if="showConfirmDialog">
      <div class="confirm-dialog" >
        <div class="title">终止悬赏</div>
        <span class="close-btn" @click="showConfirmDialog = false">
          <i class="el-icon-close" />
        </span>
        <div class="confirm-content">
          确认要终止该岗位的悬赏转发吗？终止后将停止发放对分享用户的奖励
        </div>
        <div class="dialog-footer flex flex-center">
          <el-button @click="showConfirmDialog = false">取消</el-button>
          <el-button type="danger" @click="handleConfirmEnd">确认终止</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import icon1 from '@/assets/images/reword/icon1.png'
import icon2 from '@/assets/images/reword/icon2.png'
import icon3 from '@/assets/images/reword/icon3.png'
import icon4 from '@/assets/images/reword/icon4.png'
import icon5 from '@/assets/images/reword/icon5.png'

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      rewardStatus: {
        type: Number,
        default: 1
      },
      id: {
        type: [String, Number],
        default: ''
      },
      postTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        currentPage: 1,
        pageSize: 10,
        tableTotal: 0,
        tableData: [],
        detailInfo: {},
        iconInfo: {
          icon1: icon1,
          icon2: icon2,
          icon3: icon3,
          icon4: icon4,
          icon5: icon5,
        },
        blockListOne: [
          {
            label: '悬赏范围',
            key: 'icon1',
            field: 'typeCN'
          },
          {
            label: '转发佣金（元）',
            key: 'icon2',
            field: 'singleAmount'
          },
          {
            label: '预算消耗（元）',
            key: 'icon3',
            field: 'costAmount'
          },
          {
            label: '消耗比例（%）',
            key: 'icon4',
            field: 'costRatio'
          },
          {
            label: '点击用户数（人）',
            key: 'icon5',
            field: 'clickNum'
          },
        ],
        blockListTwo: [
        {
          label: '点击用户数（人）',
          key: 'icon5',
          field: 'clickNum'
        },
        {
          label: '累计转发佣金（元）',
          key: 'icon2',
          field: 'costAmount'
        },
        ],
        showConfirmDialog: false,
      }
    },
    computed: {
      type() {
        return this.rewardStatus === 1 ? 'on' : 'end'
      }
    },
    watch: {
      show: {
        handler(val) {
          this.visible = val
          if (val) {
            this.getDetail()
          }
        },
        immediate: true
      }
    },
    methods: {
      getDetail() {
        this.axios.post(`/wapi/hr/recruit/detail/${this.id}/reward/${this.rewardStatus}`).then(res => {
          if (res.status === 200) {
            this.detailInfo = {
              ...res.data,
              typeCN: res.data.type === 1 ? '全体转发' : '精准转发',
            }
            this.getTableData()
          }
        })
      },
      getTableData() {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          rewardCode: this.detailInfo.code
        }
        this.axios.post(`/wapi/hr/recruit/detail/reward/record`, params).then(res => {
          console.log('getTableData--res', res)
          if (res.code === 200) {
            this.tableData = res.rows

            this.tableTotal = res.total
          }
        })
      },
      close() {
        this.$emit('update:show', false)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.getTableData()
      },
      handleConfirmEnd() {
        this.axios.post(`/wapi/hr/recruit/stop/reward/${this.id}`).then(res => {
          console.log('res--', res)
          if (res.status === 200) {
            this.$message.success(res.msg || '终止成功')
            this.showConfirmDialog = false
            this.close()
            this.$emit('refresh')
          }
        })
      },
      handleAllHistory() {
        this.$emit('history')
        this.close()
      },
      toConfig() {
        this.$emit('toConfig')
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
@import '~@/assets/less/base.less';

.comp-reword-form {
  /deep/ .el-dialog {
    width: 1052px;
    background: linear-gradient(133deg, rgba(212, 236, 254, 1) 0%, rgba(255, 255, 255, 1) 100%);
    border-radius: 12px;
    .dialog-title {

      .close-btn {
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        font-weight: 500;
      }
      .reword-post {
        font-weight: bold;
        font-size: 24px;
        color: rgba(0,0,0,0.85);
        line-height: 28px;
        margin-right: 10px;
      }
      .status {
        height: 24px;
        border-radius: 4px;
        padding: 0 8px;
        line-height: 24px;
        color: rgba(255, 255, 255, 1);
        &.s-on {
          background: linear-gradient( 90deg, #69A1FF 0%, #82E1FF 100%);
        }
        &.s-end {
          background: linear-gradient( 270deg, #FF8254 0%, #FF3B4B 100%);
        }
      }
    }
    .el-dialog__header {
      padding: 30px 40px 0 40px;
    }
    .el-dialog__body {
      padding: 15px 40px 40px 40px;
    }
    .info-box {
      margin-bottom: 16px;
      font-size: 16px;
      color: #040F24;
      line-height: 22px;
    }
    .reword-no:first-child {
      margin-right: 74px;

    }
    .warn {
      font-size: 12px;
      color: #FF7D00;
      line-height: 17px;
      .el-icon-warning {
        margin-right: 4px;
      }
    }
    .btn-warn {
      border-color: rgba(255, 77, 79, 1);
      color: rgba(255, 77, 79, 1);
    }
    .btn-reword {
      background: linear-gradient( 90deg, #057CF9 0%, #1AAFFD 100%);
      color: #ffffff;
    }
    .warn-btns {
      margin-bottom: 14px;
    }

    .block-item {
      width: 186px;
      height: 71px;
      background: #FFFFFF;
      border-radius: 4px;
      padding: 10px 0 0 12px;
      &:not(:last-child) {
        margin-right: 10px;
      }
      .icon-img {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }

      .text-box {
        .label {
          font-size: 12px;
          color: #4E5969;
          line-height: 17px;
          margin-bottom: 4px;
        }
        .value {
          font-size: 16px;
          color: #141414;
          line-height: 22px;
          font-weight: bold;
        }
      }
    }

    .table-box {
      width: 972px;
      max-height: 464px;
      background: #FFFFFF;
      border-radius: 7px;
      padding: 17px 24px;
      margin-top: 10px;
      .table-tit {
        margin-bottom: 8px;
        .tit {
          font-weight: bold;
          font-size: 16px;
          color: #040F24;
          line-height: 22px;
        }
        .total {
          font-size: 12px;
          color: rgba(85,85,85,0.75);
          line-height: 17px;
          margin-left: 6px;
        }
      }
    }

    .el-pagination {
      margin-top: 10px;
    }
    .el-table__header-wrapper thead div{
      background: #eef1f6;
      color: #1f2d3d;
    }

    .confirm-box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 9999;
    }
    .confirm-dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 432px;
      height: 186px;
      background: #FFFFFF;
      border-radius: 2px;
      .title {
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        color: #2B2B2B;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
      }
      .close-btn {
        position: absolute;
        right: 18px;
        top: 14px;
        font-size: 12px;
        color: #333333;
        cursor: pointer;
      }
      .confirm-content {
        font-size: 14px;
        color: #606266;
        line-height: 24px;
        padding: 21px 24px 0 24px;
      }
      .dialog-footer {
        margin-top: 16px;
        .el-button {
          width: 92px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Form.vue?3d63aa32